import React, { useEffect } from "react"
import styled from "styled-components"
import { ToastContainer } from "react-toastify"
import ReferralDashboardContainer from "container/ReferralDashboard"
import Header from "./Header"
import SearchControls from "./SearchControls"
import ReferralsTable from "./Table"
import EditDrawer from "./EditDrawer"

const Wrap = styled.div`
  padding: 20px 74px 20px 74px;

  @media(max-width: 1280px) {
    padding: 10px;
  }
`

const ReferralsDashboard = (props) => {
  const {
    getReferrals,
    getAllReferralsResponse,
  } = props

  useEffect(() => {
    getReferrals({
      skip: 0,
      limit: 25,
      status: "pre_escrow",
      sort_by: "created_at",
      sort_order: "desc",
    })
  }, [])

  const {
    isFetching,
    data: referralsData,
  } = getAllReferralsResponse || {}

  const referrals = referralsData?.referrals || []

  return (
    <Wrap>
      <Header />
      <SearchControls />
      <ReferralsTable
        referrals={referrals}
        fetchingList={isFetching}
      />
      <EditDrawer />
      <ToastContainer />
    </Wrap>
  )
}

export default ReferralDashboardContainer(ReferralsDashboard)
